import { createAgxForm, createFormDefinition } from '@urbanx/agx.forms';
import { isValidEmail } from '@urbanx/agx.ui-components2';
import { z } from 'zod';

export const agentCrmRegistrationSchema = z.object({
  emailAddress: z.string().trim().refine(isValidEmail, 'Please specify a valid email address'),
});

export const AgentCrmRegistrationForm = createAgxForm(
  createFormDefinition({
    id: 'agency-user-crm-registration',
    schema: agentCrmRegistrationSchema,
    fieldOrder: ['emailAddress'],
    resolveFields: () => ({
      emailAddress: { active: true, visible: true, disabled: false, required: true },
    }),
  })
);
